import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | number | null): string {
    if (!value) return '';

    const cleaned = value.toString().replace(/\D/g, '');
    if (cleaned.length !== 10) return value.toString();

    const areaCode = cleaned.slice(0, 3);
    const middle = cleaned.slice(3, 6);
    const last = cleaned.slice(6);

    return `(${areaCode}) ${middle}-${last}`;
  }
}